import { ROUTES } from '@/app/routes'
import type { ManifestRouteDefinition } from '@/core/manifest/types'

export const audManifestRoutes: ManifestRouteDefinition[] = [
  {
    key: 'aud_login',
    path: ROUTES.AKASHIC_AUD_LOGIN,
    isPublic: true,
    apiCalls: [],
    lazyComponent: () =>
      import('@/features/aud/pages/AudLoginPage/AudLoginPage').then((m) => ({
        default: m.default,
      })),
  },
  {
    key: 'aud_forgot_password',
    path: ROUTES.AKASHIC_AUD_FORGOT_PASSWORD,
    isPublic: true,
    apiCalls: [],
    lazyComponent: () =>
      import('@/features/aud/pages/AudForgotPasswordPage/AudForgotPasswordPage').then((m) => ({
        default: m.default,
      })),
  },
  {
    key: 'aud_upload',
    path: ROUTES.AKASHIC_AUD_UPLOAD,
    apiCalls: [],
    lazyComponent: () =>
      import('@/features/aud/pages/AudUploadPage/AudUploadPage').then((m) => ({
        default: m.default,
      })),
  },
  {
    key: 'aud_dashboard',
    path: ROUTES.AKASHIC_AUD_DASHBOARD,
    apiCalls: [],
    lazyComponent: () =>
      import('@/features/aud/pages/AudDashboardPage/AudDashboardPage').then((m) => ({
        default: m.default,
      })),
  },
  {
    key: 'aud_review',
    path: ROUTES.AKASHIC_AUD_REVIEW,
    apiCalls: [],
    lazyComponent: () =>
      import('@/features/aud/pages/AudReviewDetailPage/AudReviewDetailPage').then((m) => ({
        default: m.default,
      })),
  },
  {
    key: 'aud_support',
    path: ROUTES.AKASHIC_AUD_SUPPORT,
    isPublic: true,
    apiCalls: [],
    lazyComponent: () =>
      import('@/features/aud/pages/ComingSoonPage/AudComingSoonPage').then((m) => ({
        default: m.default,
      })),
  },
  {
    key: 'aud_settings',
    path: ROUTES.AKASHIC_AUD_SETTINGS,
    apiCalls: [],
    lazyComponent: () =>
      import('@/features/aud/pages/ComingSoonPage/AudComingSoonPage').then((m) => ({
        default: m.default,
      })),
  },
  {
    key: 'aud_notifications',
    path: ROUTES.AKASHIC_AUD_NOTIFICATIONS,
    apiCalls: [],
    lazyComponent: () =>
      import('@/features/aud/pages/ComingSoonPage/AudComingSoonPage').then((m) => ({
        default: m.default,
      })),
  },
]
